import { HorizonalGridContainerStyle, GridSlideWrapper, ListContainer } from '../style';
import { ProductListProps } from '../../../types/common';
import { useRef, useEffect } from 'react';
import CarouselHeader from '../../carouselHeader/component';

const ProducHorizontaltListCarousel: React.FC<ProductListProps> = (props) => {
  const {
    slides,
    header,
    title,
    hasMore,
    fetchMoreData,
    shouldFetch,
    showHeader,
    onCarouselScroll,
    onHeightChange,
    isLoading,
    isHorizonLayout,
  } = props;
  const loadMoreRef = useRef<HTMLDivElement | null>(null);
  const listContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!loadMoreRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry.isIntersecting && hasMore && shouldFetch && !isLoading) {
          onCarouselScroll?.();
        }
      },
      {
        root: null,
        threshold: 0.5,
      },
    );

    observer.observe(loadMoreRef.current);

    return () => observer.disconnect();
  }, [shouldFetch, hasMore, fetchMoreData, onCarouselScroll, isLoading]);

  useEffect(() => {
    if (!isHorizonLayout) return;

    const animationFrameId = window.requestAnimationFrame(() => {
      onHeightChange?.();
    });
    const timers = [100].map((delay) => window.setTimeout(() => onHeightChange?.(), delay));

    return () => {
      window.cancelAnimationFrame(animationFrameId);
      timers.forEach((timer) => window.clearTimeout(timer));
    };
  }, [slides.length, isHorizonLayout, onHeightChange]);

  return (
    <>
      {showHeader && (
        <>
          {header ? (
            <CarouselHeader title={header.title}>{header.children}</CarouselHeader>
          ) : (
            title && <CarouselHeader titleName={title} newHeader={true} />
          )}
        </>
      )}
      <ListContainer ref={listContainerRef} data-testid="product-list-container" id="scrollableDiv">
        <HorizonalGridContainerStyle data-testid="product-grid">
          {slides.map((slide, index) => (
            <GridSlideWrapper key={index}>{slide}</GridSlideWrapper>
          ))}
        </HorizonalGridContainerStyle>
      </ListContainer>
    </>
  );
};

export default ProducHorizontaltListCarousel;
